import { getArticleBySlug } from './getArticles';
import { weekDay } from '../utils/DayEnToFr';
import {formatFieldsFromStrapi} from '../utils/format'

const getBestOfPostsAPI = async (bestOfPosts: any, dispatch: any) => {
  let newBestOfPosts: { [key:string]: any[] } = {
    saturday: [],
    sunday: [],
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
  };
  dispatch({type: 'UPDATE_LOADING', payload: { isLoading: 1 }});

  const setNewBestOfPosts = (object: any) => {
    newBestOfPosts = object;
  }

  const addPostBestOfByDay = (day: any, post: any) => {
    day = day.toLowerCase();
    let array = newBestOfPosts[day].filter((postDay) => postDay === post);
    if (array.length === 0) {
      setNewBestOfPosts({ ...newBestOfPosts, [day]: [...newBestOfPosts[day], post] });
    }
  };

  for (let i = 0; i < weekDay.length; i++) {
    for (let j = 0; j < bestOfPosts[weekDay[i]].length; j++) {
      await getArticleBySlug(bestOfPosts[weekDay[i]][j].slug)
        .then(res => {
          addPostBestOfByDay(weekDay[i], formatFieldsFromStrapi(res.data));
        })
        .catch(err => console.log(err));
    }
  }
  dispatch({type: 'UPDATE_LOADING', payload: { isLoading: 0 }});
  dispatch({type: 'SET_POST_DAY', payload: { postByDay: newBestOfPosts}});
  return (newBestOfPosts);
};

export default getBestOfPostsAPI;

export const getPostAPI = async (array: any, dispatch: any) => {
  let newArray: any[] = []

  const setArray = (array: any[]) => {
    newArray = array;
  }

  const addToArray = (data: any) => {
    setArray([...newArray, data]);
  };

  for (let j = 0; j < array.length; j++) {
    await getArticleBySlug(array[j].slug)
      .then(res => {
        addToArray(formatFieldsFromStrapi(res.data));
      })
      .catch(err => console.log(err));
  }
  dispatch({type: "SET_ARTICLE_COVER", payload: {postCover: newArray}})
  return (newArray);
}